import React from 'react'
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap'
import FormCard from '../common/FormCard'

function DistributorsEditCard({
  distributor,
  formData,
  errors,
  submitted,
  isSaving,
  message,
  onInputChange,
  onSubmit,
  onCancel,
}) {
  if (!distributor) {
    return null
  }

  return (
    <FormCard
      title="Editar distribuidor"
      onSubmit={onSubmit}
      onCancel={onCancel}
      submitLabel="Guardar cambios"
      showCancel
      isSubmitting={isSaving}
      errorMessage={message && !message.includes('correctamente') ? message : ''}
      successMessage={message && message.includes('correctamente') ? message : ''}
    >
      <FormGroup>
        <Label for="edit-name">
          Nombre <span className="text-danger">*</span>
        </Label>
        <Input
          type="text"
          name="name"
          id="edit-name"
          placeholder="Nombre del distribuidor"
          value={formData.name}
          onChange={onInputChange}
          invalid={submitted && !!errors.name}
        />
        {submitted && errors.name && (
          <FormFeedback>{errors.name}</FormFeedback>
        )}
      </FormGroup>
    </FormCard>
  )
}

export default DistributorsEditCard
